module.exports = __webpack_public_path__ + "img/test.3615d696.png";